import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { HOME_INSURANCE_RISK_MESSAGES } from '../../../constants/messages'
import { HOME_INSURANCE_RISKS } from '../../../constants/homeInsurance'
import { Text } from '../..'

import styles from './RiskMessage.module.scss'

const RiskMessage = ({ risk, className, ...restProps }) => {
  return (
    <Text element='span' weight='bold' className={classnames(styles[`risk-color-${risk}`], className)} {...restProps}>
      {risk && <FormattedMessage {...HOME_INSURANCE_RISK_MESSAGES[risk]} />}
    </Text>
  )
}

RiskMessage.propTypes = {
  risk: PropTypes.oneOf(Object.values(HOME_INSURANCE_RISKS)).isRequired,
  className: PropTypes.string
}

export default RiskMessage
